/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Civil_Slow_Mare_ScoldInputs */

const fr_civil_slow_mare_scold = /** @type {(inputs: Civil_Slow_Mare_ScoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visiteurs`)
};

/**

* @param {Civil_Slow_Mare_ScoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const civil_slow_mare_scold = /** @type {((inputs?: Civil_Slow_Mare_ScoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Civil_Slow_Mare_ScoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_civil_slow_mare_scold(inputs)
});